export default "__VITE_ASSET__Bd5ibla1__"